/**
 * Pure functions for displaying facility data in UI.
 * Single responsibility: format address for display.
 */

/**
 * Format facility address for display (supports both API shapes).
 * @param {Object} facility - Facility with address or street/city/state/zipCode
 * @returns {string}
 */
export function formatFacilityAddress(facility) {
  if (!facility) return '';

  if (facility.address) {
    return facility.address;
  }

  const { street, city, state, zipCode } = facility;
  if (!street && !city && !state && !zipCode) {
    return 'No address provided';
  }

  const parts = [street, city, state, zipCode].filter(Boolean);
  return parts.join(', ');
}
